window.Clipboard = ((window, document, navigator) => {
  let textArea;
  let parentElement;

  function isIOS() {
    return navigator.userAgent.match(/ipad|iphone/i)
      || navigator.platform.match(/ipad|iphone/i);
  }

  function createTextArea(text) {
    textArea = document.createElement('textArea');
    textArea.style = 'position: absolute; left: -1000px; top: -1000px;';
    textArea.value = text;
    parentElement.appendChild(textArea);
  }

  function selectText() {
    if (isIOS()) {
      textArea.select();
      textArea.setSelectionRange(0, 99999);
    } else {
      textArea.select();
    }
  }

  function copyToClipboard() {
    document.execCommand('copy');
    parentElement.removeChild(textArea);
  }

  const copy = (text, elementToAppend) => {
    parentElement = elementToAppend || document.body;
    createTextArea(text, elementToAppend);
    selectText();
    copyToClipboard();
  };

  return {
    copy,
  };
})(window, document, navigator);
